import { render } from "./AcademicProbationAndWarning.vue?vue&type=template&id=9d28029a"
import script from "./AcademicProbationAndWarning.vue?vue&type=script&lang=js"
export * from "./AcademicProbationAndWarning.vue?vue&type=script&lang=js"
script.render = render

export default script